import React from "react";
import { useTranslation } from "react-i18next";
import { Box, TextField, FormControlLabel, Switch } from "@mui/material";
import { useSelector } from "react-redux";

export default function RenderContent({ formData, setFormData }) {
    const [t] = useTranslation("common");
    const maintheme = useSelector((state) => state.themeData.maintheme);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                marginTop: 2,
            }}
        >
            <TextField
                label={t("CONTRACTORS.name") || "الاسم"}
                variant="outlined"
                fullWidth
                required
                value={formData?.name || ""}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                sx={{
                    "& .MuiInputLabel-root": {
                        fontFamily: "Cairo-Medium",
                    },
                    "& .MuiInputBase-input": {
                        fontFamily: "Cairo-Medium",
                    },
                }}
            />
            <TextField
                label={t("CONTRACTORS.code") || "الكود"}
                variant="outlined"
                fullWidth
                value={formData?.code || ""}
                onChange={(e) => setFormData({ ...formData, code: e.target.value })}
                sx={{
                    "& .MuiInputLabel-root": {
                        fontFamily: "Cairo-Medium",
                    },
                    "& .MuiInputBase-input": {
                        fontFamily: "Cairo-Medium",
                    },
                }}
            />
            <FormControlLabel
                control={
                    <Switch
                        checked={formData?.enabled === 1}
                        onChange={(e) =>
                            setFormData({ ...formData, enabled: e.target.checked ? 1 : 0 })
                        }
                        color="primary"
                    />
                }
                label={t("CONTRACTORS.enabled") || "مفعل"}
                sx={{
                    "& .MuiFormControlLabel-label": {
                        fontFamily: "Cairo-Medium",
                    },
                }}
            />
        </Box>
    );
}

